exports = module.exports = require("../../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".bg-colored[data-v-1d1ff957]{background-color:#060181!important}.bg-inDarkActive[data-v-1d1ff957]:active{background-color:rgba(6,1,129,.3)!important}", ""]);

// exports
